import { render, staticRenderFns } from "./activityAdd.vue?vue&type=template&id=970719fe&scoped=true"
import script from "./activityAdd.vue?vue&type=script&lang=js"
export * from "./activityAdd.vue?vue&type=script&lang=js"
import style0 from "./activityAdd.vue?vue&type=style&index=0&id=970719fe&prod&lang=scss&scoped=true"
import style1 from "./activityAdd.vue?vue&type=style&index=1&id=970719fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970719fe",
  null
  
)

export default component.exports